import React, { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import BrandIcon from "../assets/BrandIcon.png";

const Header = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const navItems = useMemo(
    () => [
      { label: "Home", to: "/" },
      { label: "Services", to: "/services" },
      { label: "FAQ", to: "/faq" },
      { label: "About", to: "/about" },
      { label: "Blog", to: "/blog" },
      { label: "Contact", to: "/contact" }
    ],
    []
  );

  const close = () => setOpen(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-white">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-10 -right-16 h-56 w-56 rounded-full bg-[color:var(--brand-accent)]/18 blur-3xl" />
        <div className="absolute -bottom-16 -left-10 h-56 w-56 rounded-full bg-black/18 blur-3xl" />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <NavLink
          to="/"
          onClick={close}
          className="flex items-center gap-3 min-w-0"
        >
          <div className="flex items-center justify-center">
            <img
              src={BrandIcon}
              alt="Qualityzone"
              className="h-14 sm:h-16 lg:h-18 xl:h-18 w-auto object-contain"
            />
          </div>
        </NavLink>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-2">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={close}
              className={({ isActive }) =>
                `rounded-lg px-4 py-2 text-[15px] font-semibold transition-all duration-200 ${
                  isActive
                    ? "bg-[color:var(--brand)] text-white shadow-sm"
                    : "text-[color:var(--brand)] hover:bg-[color:var(--brand)] hover:text-white hover:shadow-sm"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden lg:flex items-center gap-3">
          <NavLink
            to="/book"
            className="
              inline-flex items-center justify-center
              rounded-lg px-4 py-2
              text-sm font-semibold
              bg-[color:var(--brand)]
              text-white
              border border-white/20
              hover:bg-[color:var(--brand)]
              hover:text-white
              hover:border-white/40
              transition duration-200
              shadow-md
            "
          >
            Book a Call
          </NavLink>

          <NavLink
            to="/contact"
            className="inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:brightness-95 transition duration-200 shadow-sm"
          >
            Get in Touch
          </NavLink>
        </div>

        {/* Mobile Toggle */}
        <button
          type="button"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden inline-flex items-center justify-center h-11 w-11 rounded-xl bg-white border border-white/15 shadow-sm transition"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path
              d={open ? "M6 6L18 18M18 6L6 18" : "M4 7H20M4 12H20M4 17H20"}
              stroke="var(--brand)"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-300 ${
          open ? "max-h-[560px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-[color:var(--brand)] text-white border-t border-white/10">
          <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 py-5">
            <div className="grid gap-2">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={close}
                  className={({ isActive }) =>
                    `w-full rounded-xl px-4 py-3 text-center text-[15px] font-semibold transition ${
                      isActive
                        ? "bg-white text-[color:var(--brand)]"
                        : "hover:bg-white/20 hover:text-white active:bg-white/30"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>

            <div className="mt-4 grid gap-2">
              <NavLink
                to="/book"
                onClick={close}
                className="inline-flex items-center justify-center rounded-xl px-4 py-3 text-sm font-semibold bg-white/20 text-white hover:bg-[color:var(--brand-accent)] transition"
              >
                Schedule a Call
              </NavLink>

              <NavLink
                to="/contact"
                onClick={close}
                className="inline-flex items-center justify-center rounded-xl px-4 py-3 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:brightness-95 transition"
              >
                Get in Touch
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
